module.exports = __webpack_public_path__ + "static/media/c-small.059ca445.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/planets/c-small.png
// module id = 1874
// module chunks = 0